import { isServiceError } from '../isServiceError';

/**
 * Filter to prevent logging errors that are due to a request timeout,
 * since these are expected and not actionable.
 */
export class RequestTimeoutFilter {
  constructor() {
    this.messages = ['Request timeout', 'Request aborted'];
  }
  isLoggable(record) {
    const [maybeError] = record.messages;
    if (!(maybeError instanceof Error)) {
      return true;
    }
    const cause = maybeError.cause;
    if (!isServiceError(cause)) {
      return true;
    }
    return !this.messages.includes(cause.error.statusText);
  }
}